import { IVillageForListPresenterSchema } from '../../../node/repositories/countryside-search/entities/village/VillageForListPresenterSchema';

enum FVillageBuildingsType {
  Unexpected = 0,
  House = 1,
  Land = 3,
  Townhouse = 4,
}

export function getVillageBuildingTypes(village: IVillageForListPresenterSchema): string {
  const categorySet = village.newobjectCategorySet;
  const buildingTypes: number[] = [];

  if (categorySet) {
    if (categorySet.cottage || categorySet.lowrisehouse) {
      buildingTypes.push(FVillageBuildingsType.House);
    }
    if (categorySet.landplot) {
      buildingTypes.push(FVillageBuildingsType.Land);
    }
    if (categorySet.townhouse) {
      buildingTypes.push(FVillageBuildingsType.Townhouse);
    }

    return buildingTypes.join(',');
  } else {
    return FVillageBuildingsType.Unexpected.toString();
  }
}
